<template>
  <svg width="4" height="20" viewBox="0 0 4 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="4" height="20" fill="#1E1E1E" />
  </svg>
</template>
